var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCheckOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53688 13.4989C2.53688 7.83902 7.82589 3.5 14.0185 3.5C20.211 3.5 25.5 7.83902 25.5 13.4989C25.5 19.1589 20.211 23.4979 14.0185 23.4979C12.6453 23.4979 11.3254 23.288 10.1005 22.9013C8.65562 24.2498 6.55631 24.898 3.98829 24.9989C2.94219 25.04 2.18713 23.9519 2.62516 22.978C3.24656 21.5866 4.04946 19.9915 4.14467 18.6002C3.12784 17.1195 2.53688 15.3721 2.53688 13.4989ZM14.0185 5.5C8.63339 5.5 4.53688 9.21891 4.53688 13.4989C4.53688 15.0359 5.05151 16.4778 5.95874 17.6996C6.08676 17.872 6.15588 18.081 6.15588 18.2957C6.15588 19.9295 5.50461 21.471 4.84145 22.9339C6.89752 22.7155 8.24636 22.0571 9.05971 21.1C9.33288 20.7786 9.77839 20.6631 10.1733 20.8114C11.3455 21.2516 12.6458 21.4979 14.0185 21.4979C19.4035 21.4979 23.5 17.779 23.5 13.4989C23.5 9.21891 19.4035 5.5 14.0185 5.5Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2071 10.2929C18.5977 10.6834 18.5977 11.3166 18.2071 11.7071L13.2071 16.7071C12.8166 17.0976 12.1835 17.0976 11.7929 16.7071L9.79294 14.7071C9.40241 14.3166 9.40241 13.6834 9.79294 13.2929C10.1835 12.9024 10.8166 12.9024 11.2071 13.2929L12.5 14.5858L16.7929 10.2929C17.1835 9.90237 17.8166 9.90237 18.2071 10.2929Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCheckOutline);
export default __webpack_public_path__ + "static/media/message_check_outline.f0fa79ccbda48b906e9f04dc8569ff86.svg";
export { ForwardRef as ReactComponent };